import { rgba } from 'polished'
import { MdChevronRight } from 'react-icons/md'
import { Box, BoxComponentProps } from 'reoil'
import { useThemeValue } from '../../store/themeState'
import goto from '../../utils/goto'

interface JobCardProps {
  id: string | number
  title: string
  posts: string[]
  locations: {name: string}[]
  company: string
}

const JobCard: React.FC<BoxComponentProps & JobCardProps> = ({id, title, posts=[], locations=[], company, ...props}) => {
  const theme = useThemeValue()

  const chipColor1 = rgba(theme.colors.primary, .2)
  const chipColor2 = rgba(theme.colors.secondary, .2)

  const handleClick = ()=>{
    goto(`/jobs/${id}`)
  }

  return(
    <Box className='JobCard' row stretch bg='white' p={2} py={3} borderRadius={1} boxShadow='card' mb={3} onClick={handleClick} pointer {...props}>
      <Box className='left' flex={1} stretch>
        <Box mb={2} lineHeight={1.5} mr={1}><h3>{title} <span style={{opacity: .6, fontSize: 14}}>{company}</span></h3></Box>
        <Box row flexWrap='wrap'>
          {posts.map((post, i)=>(
            <Box key={i} className="chip" fontSize={0} bg={chipColor1} color='primary' px={2} py={1} borderRadius={0} mt={2} mr={2}>{post}</Box>
          ))}
          {locations.map((location, i)=>(
            <Box key={i} className="chip" fontSize={0} bg={chipColor2} color='secondary' px={2} py={1} borderRadius={0} mt={2} mr={2}>{location.name}</Box>
          ))}
        </Box>
      </Box>
      <Box className="right" ml='auto' center>
        <MdChevronRight />
      </Box>
    </Box>
  )
}

export default JobCard
